import React from 'react';
import cx from 'classnames';

interface Props {
  tailwindColor?: string;
  className?: string;
  height?: number;
}

const Search: React.FC<Props> = ({
  height = 20,
  tailwindColor = `flprimary`,
  className,
}) => (
  <svg
    className={cx(className, `inline-block`)}
    width={(82 / 91) * height}
    height={height}
    viewBox="0 0 820 909"
  >
    <path
      className={cx(`text-${tailwindColor}`, `fill-current`)}
      d="M297 40.4c-24.2 3.2-47.5 5.3-71 12.5C162.6 72.4 108.9 112.6 68.5 165a269.3 269.3 0 00-35.7 64A289.1 289.1 0 0011 348c4.1 93 57.4 182.4 135 233.1 30 19.6 63 35.5 98 43.7 31 7.2 64.4 8 96 5 25-2.3 49.8-9.8 73-19 6-2.4 12-5.3 18-7.8 3-1.3 5.8-2.6 8.8-.6 8 5.4 14.4 14.8 21.2 21.6l46 46c50.5 50.5 100.5 101.5 151 152a2176 2176 0 0035 34c11 10.5 22.5 24 37 29.5 10.2 4 23.5 3.3 34 1 35.5-7.8 53.2-49.3 40.5-81.5-5-12.5-16-21.3-24.8-31-24.6-27.4-51.7-53-77.7-79-34.2-34.2-67.8-68.8-102-103-16.2-16.2-32.7-32.2-48.4-48.8L540 531c-1.9-1.9-5-4.2-5.4-7-.6-4.2 5.7-9.9 8-13 7.8-11 15.3-22.3 22-34a292.4 292.4 0 0036.1-109C617.5 232.7 525.8 100.7 399 56.7A271.9 271.9 0 00322 41c-8.4-.4-16.6-1.7-25-.6m3 79.9c4.4-.5 8.6.6 13 .7 19.3.2 38.4 2.3 57 7.6 34.4 9.8 68.1 27 93 53.4 26.3 28 45.5 63.5 54.3 101 4.1 17.2 4.7 34.4 4.7 52 0 14.4 0 28.7-2.4 43-8.9 52.8-39.3 104.4-83.6 135a221.4 221.4 0 01-106 37.8c-60.6 5.8-124.2-10.6-170-52-87.7-79.2-92.6-229.5-11-314.8a210.6 210.6 0 01103-57.8c16-3.7 31.8-4.2 48-6z"
    />
  </svg>
);

export default Search;
